import * as Yup from "yup";
import { capitalizeWords } from "@utils/index";

const capitalizeTransform = (value: string) => capitalizeWords(value);

const attributesSchema = Yup.object().shape({
  BPID: Yup.string().when("$profile", {
    is: (profile: string) => profile === "carrier",
    then: Yup.string()
      .required("Preencha o BP ID")
      .trim()
      .transform(capitalizeTransform),
    otherwise: Yup.string().nullable(),
  }),
  INTERNAL_NAME: Yup.string().when("profile", {
    is: (profile: string) => profile === "CARRIER",
    then: Yup.string()
      .required("Preencha o INTERNAL_NAME")
      .trim()
      .transform(capitalizeTransform),
    otherwise: Yup.string().nullable(),
  }),
  CNPJ: Yup.array()
    .of(
      Yup.object().shape({
        CNPJ: Yup.string().required().trim(),
        companyName: Yup.string().uppercase().required().trim(),
      })
    )
    .required("Preencha pelo menos um CNPJ"),
});

export const baseUserFields = {
  firstName: Yup.string()
    .required("Preencha o primeiro nome")
    .trim()
    .transform(capitalizeTransform),
  lastName: Yup.string()
    .required("Preencha o último nome")
    .trim()
    .transform(capitalizeTransform),
  email: Yup.string()
    .email("Digite um email válido")
    .lowercase()
    .trim()
    .required("Preencha o e-mail"),
  profile: Yup.string().required("Selecione um perfil"),
  attributes: attributesSchema,
};
